module.exports = __webpack_public_path__ + "img/marketplace_LINE.e1c1a1b1.svg";